module.exports = __webpack_public_path__ + "img/logo-ecsystemone.112dbbd1.png";